import { createFileRoute } from '@tanstack/react-router';

import ComingSoonCover from '@/components/ComingSoonCover';

export const Route = createFileRoute(
  '/_staff/accesses/_layout/_placeholders/software',
)({
  component: () => <ComingSoonCover />,
});
